import { ENRICHMENT_ANSWER_TYPE_PHONE } from "../enrichmentAnswerTypes";

export function isEnrichmentAnswerTypePhone(enrichment) {
    return enrichment.answer_type == ENRICHMENT_ANSWER_TYPE_PHONE;
}
